export function getParam(name) {
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]")
  var regex = new RegExp("[\\?&]"+name+"=([^&#]*)")
  var results = regex.exec(window.location.href)
  if (!results || results.length < 2) return null
  return results[1]
}

export function getBaseUrl() {
  return window.location.protocol+'//'+window.location.hostname+(window.location.port ? ':'+window.location.port: '')
}



// WEBPACK FOOTER //
// ./src/app/util/url.js